<div class="badge" [class]="size" [attr.data-type]="type">
  <strong>{{ label }}</strong>
</div>
